import React, { useCallback } from "react";
import { Link, useSearchParams } from "react-router-dom";
import "./VolcanSidebar.css";

import descripcionIcon from "../../../assets/images/menu/descripcion.png";
import descripcionIconActive from "../../../assets/images/menu/descripcion_active.png";

import documentosIcon from "../../../assets/images/menu/documentos.png";
import documentosIconActive from "../../../assets/images/menu/documentos_active.png";

import cartografiaIcon from "../../../assets/images/menu/cartografia_historica.png";
import cartografiaIconActive from "../../../assets/images/menu/cartografia_historica_active.png";

import amenazaIcon from "../../../assets/images/menu/mapas_amenaza.png";
import amenazaIconActive from "../../../assets/images/menu/mapas_amenaza_active.png";

import lineaTimepoIcon from "../../../assets/images/menu/linea_tiempo.png";
import lineaTiempoIconActive from "../../../assets/images/menu/linea_tiempo_active.png";

function VolcanSidebar({
  activeTab,
  setActiveTab,
  sidebarOpen,
  setSidebarOpen,
}) {
  const [searchParams] = useSearchParams();
  const volcanIdFromUrl =
    searchParams.get("id") ?? searchParams.get("volcanId");
  const hasVolcanId = volcanIdFromUrl != null && String(volcanIdFromUrl).trim();

  const makeHref = useCallback(
    (tabKey) => {
      if (!hasVolcanId) return null;
      const baseId = String(volcanIdFromUrl).trim();
      return `/volcan-detalle?id=${encodeURIComponent(baseId)}&tab=${encodeURIComponent(tabKey)}`;
    },
    [hasVolcanId, volcanIdFromUrl],
  );

  const menuItems = [
    {
      key: "descripcion",
      label: "Descripción",
      icon: descripcionIcon,
      activeIcon: descripcionIconActive,
    },
    {
      key: "timeline",
      label: "Línea de tiempo",
      icon: lineaTimepoIcon,
      activeIcon: lineaTiempoIconActive,
    },
    {
      key: "cartografia_historica",
      label: "Cartografía histórica",
      icon: cartografiaIcon,
      activeIcon: cartografiaIconActive,
    },
    {
      key: "mapas_amenaza",
      label: "Mapas de amenaza",
      collapsedLabel: (
        <>
          Mapa de
          <br />
          amenazas
        </>
      ),
      icon: amenazaIcon,
      activeIcon: amenazaIconActive,
    },
    {
      key: "documentos",
      label: "Documentos",
      icon: documentosIcon,
      activeIcon: documentosIconActive,
    },
  ];

  return (
    <>
      {sidebarOpen ? (
        <button
          type="button"
          className="sidebar-backdrop"
          aria-label="Cerrar menú"
          onClick={() => setSidebarOpen(false)}
        />
      ) : null}
      <div className={`sidebar ${sidebarOpen ? "open" : "closed"}`}>
        <div className="sidebar-header">
          <button
            type="button"
            className="toggle-btn"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            data-sgc-tooltip={sidebarOpen ? "Contraer menú" : "Expandir menú"}
            data-sgc-tooltip-pos="right"
            aria-label={sidebarOpen ? "Contraer menú" : "Expandir menú"}
            aria-expanded={sidebarOpen}
          >
            <i className="bi bi-layout-sidebar-inset" aria-hidden />
          </button>
        </div>

        <ul className="sidebar-menu">
          {menuItems.map((item) => {
            const isActive = activeTab === item.key;
            const iconSrc = isActive ? item.activeIcon : item.icon;

            return (
              <li
                key={item.key}
                className={`sidebar-item${isActive ? " active" : ""}`}
                aria-label={item.label}
              >
                {makeHref(item.key) ? (
                  <Link
                    to={makeHref(item.key)}
                    className="sidebar-link"
                    onClick={() => {
                      setActiveTab(item.key);
                      if (
                        typeof window !== "undefined" &&
                        window.matchMedia("(max-width: 768px)").matches
                      ) {
                        setSidebarOpen(false);
                      }
                    }}
                  >
                    <span
                      className="sidebar-icon-wrap sidebar-icon-wrap--circle"
                      aria-hidden="true"
                    >
                      <img src={iconSrc} alt="" className="sidebar-icon-img" />
                    </span>
                    <span className="sidebar-label">
                      {!sidebarOpen && item.collapsedLabel
                        ? item.collapsedLabel
                        : item.label}
                    </span>
                  </Link>
                ) : (
                  <button
                    type="button"
                    className="sidebar-link sidebar-link--button"
                    onClick={() => {
                      setActiveTab(item.key);
                      if (
                        typeof window !== "undefined" &&
                        window.matchMedia("(max-width: 768px)").matches
                      ) {
                        setSidebarOpen(false);
                      }
                    }}
                  >
                    <span
                      className="sidebar-icon-wrap sidebar-icon-wrap--circle"
                      aria-hidden="true"
                    >
                      <img src={iconSrc} alt="" className="sidebar-icon-img" />
                    </span>
                    <span className="sidebar-label">
                      {!sidebarOpen && item.collapsedLabel
                        ? item.collapsedLabel
                        : item.label}
                    </span>
                  </button>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
}

export default VolcanSidebar;
